import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Stack,
  IconButton,
  Button,
  Divider,
} from "@mui/material";
import { Plus, Folder, X, Tag } from "lucide-react";

export default function AddCategoryForm() {
  const [category, setCategory] = useState("");
  const [subCategories, setSubCategories] = useState([""]);

  const handleAddSubCat = () => {
    setSubCategories([...subCategories, ""]);
  };

  const handleRemoveSubCat = (index) => {
    if (subCategories.length === 1) return;
    setSubCategories(subCategories.filter((_, i) => i !== index));
  };

  const handleSubCatChange = (index, value) => {
    const updated = [...subCategories];
    updated[index] = value;
    setSubCategories(updated);
  };

  const handleSubmit = () => {
    const data = {
      category,
      subCategories: subCategories.filter((s) => s.trim() !== ""),
    };
    console.log("Submitted:", data);
  };

  return (
    <Card sx={{ maxWidth: 600, mx: "auto", p: 2, mt: 4, borderRadius: 3 }}>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <Folder size={22} />
          <Typography variant="h6">Add Category</Typography>
        </Stack>

        {/* Category Input */}
        <TextField
          label="Category Name"
          fullWidth
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          InputProps={{
            startAdornment: <Tag size={18} style={{ marginRight: 8 }} />,
          }}
        />

        <Divider sx={{ my: 3 }} />

        {/* Subcategories List */}
        <Stack spacing={2}>
          <Typography variant="subtitle1" fontWeight="medium">
            Subcategories
          </Typography>

          {subCategories.map((sub, index) => (
            <Stack key={index} direction="row" spacing={1} alignItems="center">
              <TextField
                label={`Subcategory ${index + 1}`}
                fullWidth
                value={sub}
                onChange={(e) => handleSubCatChange(index, e.target.value)}
              />

              <IconButton
                color="error"
                onClick={() => handleRemoveSubCat(index)}
              >
                <X size={18} />
              </IconButton>
            </Stack>
          ))}

          <Button
            startIcon={<Plus size={18} />}
            variant="outlined"
            onClick={handleAddSubCat}
            sx={{ alignSelf: "flex-start", mt: 1 }}
          >
            Add Subcategory
          </Button>
        </Stack>

        <Divider sx={{ my: 3 }} />

        {/* Submit */}
        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={handleSubmit}
          sx={{ textTransform: "none", py: 1.2 }}
        >
          Save Category
        </Button>
      </CardContent>
    </Card>
  );
}
